<template>
    <v-card elevation="0" class="ml-4 pr-2" color="white">
        <div class="d-flex mt-12 px-3 pt-6 pb-4 justify-space-between" color="primary--text text--darken-1">
            <router-link class="nav_link primary--text text--darken-1" :to="`/users`" replace>
                <v-icon small class="mt-n1" color="primary darken-1">mdi-menu-left</v-icon> Users
            </router-link>
        </div>
        <div class="px-4 mt-4 title general_grey--text text--darken-1">{{ updateUser.first_name }} {{ updateUser.last_name }}</div>
        <div class="px-4 mb-6 subtitle general_grey--text text--darken-1">
            <div id="copy-email" class="d-inline">{{ updateUser.user_email }}</div> 
            <v-tooltip 
                v-model="trigger_copied"
                right>
                <template v-slot:activator="{ }">
                    <v-icon small class="ml-4 mt-n1 d-inline" color="primary darken-1" @click="handleCopyEmail">mdi-content-copy</v-icon>
                </template>
                <span>copied</span>
            </v-tooltip>
        </div>
        <div class="px-4 mb-3 general_grey--text text--darken-1">
            <div class="d-block">Created: {{ formatLastLoginDate(updateUser.created_date) }}</div>
            <div class="d-block">Last login: {{ formatLastLoginDate(updateUser.last_logged_in) }}</div>
            <div v-if="formatLastLoginDate(updateUser.last_logged_in) == 'never'"
                    class="d-block mt-4 d-flex justify-center">
                <ResendWelcomeButton 
                    class="flex-grow-1"
                    :userData="updateUser" />
            </div>
            <div class="d-block mt-4 d-flex justify-center">
                <ResetPasswordButton 
                    class="flex-grow-1"
                    :userData="updateUser" />
            </div>
        </div>

        <v-divider></v-divider>
        <v-form v-model="valid_user_save" ref="userform">
        <v-card-text color="pewter" class="pt-6 pr-9">
            <v-row> 
                <v-col cols="12" sm="12" md="0" class="pb-0">    
                    <v-text-field 
                        v-model="updateUser.first_name" 
                        :rules="firstNameRules"
                        required
                        label="First Name">
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12" md="0" class="pb-0">
                    <v-text-field 
                        v-model="updateUser.last_name" 
                        :rules="lastNameRules"
                        required
                        label="Last Name">
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row>    
                <v-col cols="12" sm="12" md="0" class="pb-0">
                    <CrdLookupField
                        :updateUser="updateUser"
                        :userFeedback="userFeedback" />
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12" md="0" class="pb-0">
                    <v-autocomplete
                        v-model="updateUser.title"
                        :items="Titles"
                        label="Title">
                    </v-autocomplete>
                </v-col>
            </v-row>
            <v-row>    
                <v-col cols="12" sm="12" md="0" class="pb-0">
                    <v-text-field 
                        v-model="updateUser.user_email" 
                        :rules="emailRules"
                        required
                        label="Email">
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12" md="0" class="pb-0">
                    <v-text-field 
                        v-model="updateUser.phone" 
                        label="Phone">
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row>    
                <v-col cols="12" sm="12" md="0" class="pb-0">
                    <v-text-field 
                        v-model="updateUser.company" 
                        label="Company">
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12" md="0" class="pb-0">
                    <v-text-field 
                        v-model="updateUser.website" 
                        label="Website">
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row>    
                <v-col cols="12" sm="12" md="0" class="pb-0">
                    <v-text-field 
                        v-model="updateUser.address" 
                        label="Mailing Address">
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row>    
                <v-col cols="12" sm="12" md="0" class="pb-0">
                    <v-text-field 
                        v-model="updateUser.address2" 
                        label="Second Address Line">
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12" md="0" class="pb-0">
                    <v-text-field 
                        v-model="updateUser.city" 
                        label="City">
                    </v-text-field>
                </v-col> 
            </v-row>
            <v-row> 
                <v-col cols="12" sm="12" md="0" class="pb-0">
                    <v-select
                        v-model="updateUser.state"
                        :items="States"
                        label="State">
                    </v-select>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12" md="0" class="pb-0">
                    <v-text-field 
                        v-model="updateUser.postal" 
                        label="Zip Code">
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12" md="0" class="pb-0">
                    <div class="d-block mb-n2">Role:</div>
                    <v-radio-group v-model="updateUser.group" row>
                        <v-radio label="SRG Admin" :value="6" color="success darken-2" class="mx-0"></v-radio>
                        <v-radio label="Client" :value="4"  color="success darken-2" class="mx-2"></v-radio>
                        <v-radio label="Partner Firm" :value="7"  color="success darken-2" class="ml-2 mr-0"></v-radio>
                    </v-radio-group>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="12" md="0" class="d-flex justify-center py-0">
                    <v-switch 
                        v-model="updateUser.is_active" 
                        color="success darken-2" 
                        :label="'Active User'"
                        inset>
                    </v-switch>
                </v-col>
            </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-center">
            <v-btn 
                v-if="isAdminAdv"
                color="error"
                outlined
                class="d-block mr-3"
                @click="rmUser">
                Delete User
            </v-btn>
            <v-btn 
                color="info" 
                class="my-3 d-block"
                @click="updateData">
                Update User
            </v-btn>
        </v-card-actions>
        </v-form>
    </v-card>
</template>

<script>
    import { dataTimeDisplayFormatter } from './utilities'
    import ResendWelcomeButton from './shared/resendWelcome.vue';
    import ResetPasswordButton from './shared/resetPassword.vue';
    import CrdLookupField from './shared/CrdLookupField.vue';

    export default {
        name: 'UpdateUser',
        
        components: {
            CrdLookupField,
            ResendWelcomeButton,
            ResetPasswordButton
        },

        props: {
            isRootAdmin: Boolean,
            isSuperAdmin: Boolean,
            isAdminAdv: Boolean,
            States: Array,
            Titles: Array,
            updateUser: Object,
            userFeedback: Function,
            deleteUser: Function,
            saveUserData: Function,
        },
        
        data () {
            return {
                valid_user_save: false,
                trigger_copied: false,
                firstNameRules: [
                    (v) => !!v || 'First Name is required'
                ],
                lastNameRules: [
                    (v) => !!v || 'Last Name is required'
                ],
                emailRules: [
                    (v) => !!v || 'Email is required',
                    (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,9})+$/.test(v) || 'Email must be in valid format'
                ]
            }
        },

    watch: {
    },
    
    methods: {
        updateData: function () {
            this.$refs.userform.validate();
            if(this.valid_user_save){
                const { crd_number, crd_verified, disclosures, ...payload } = this.updateUser;
                this.$emit('saveUserData', payload);
            }
        },

        // formatLastLoginDate (date, digits_of_year=4) {
        //     if ( date == null ) return 'never';
            
        //     const [year, month, day] = date.substr(0,10).split('-');
        //     return `${month}/${day}/${digits_of_year == 2 ? year.substr(2,2) : year}`;
        // },
        formatLastLoginDate: function ( date ) {
            if ( date == null ) return 'never'

            const options = {
                month: 'short', 
                day: 'numeric', 
                year: 'numeric'
            }
            return dataTimeDisplayFormatter(date, options)
        },

        rmUser: function () {
            this.$emit('deleteUser', this.updateUser);
        },
        
        handleCopyEmail: function () {
            navigator.clipboard.writeText(document.querySelector('div#copy-email').innerText)
            this.trigger_copied = true;
            setTimeout(() => { this.trigger_copied = false; }, 3000);
        }
    }
}
</script>

<style scoped>
    .nav_link {
        font-size: large;
        text-decoration: none;
    }
</style>


// WEBPACK FOOTER //
// src/components/UpdateUser.vue